import { IAction } from 'core/interface/action';

export const SAVE_VALUES = 'save-skills';

const defaultState = {
  skills: null,
};

export const SaveSkills = (value: any | number[]) => ({
  type: SAVE_VALUES,
  payload: value
});

const skillsReducer = (
  state = defaultState,
  action: IAction<any | number[]>
) => {
  switch (action.type) {
    case SAVE_VALUES:
      return {
        ...state,
        skills: action.payload
      };
    default:
      return state;
  }
};

export default skillsReducer;
